define('SuiteDynamics.PDPImageGalleryGrid.ImageGallery',
    [
        'ProductDetails.ImageGallery.View',
        'suitedynamics_pdpimagegallerygrid_imagegallery.tpl'
    ],
    function (
        ProductDetailsImageGalleryView,
        suitedynamics_pdpimagegallerygrid_imagegallery_tpl
    )
{
    'use strict';

    return {
        mountToApp: function mountToApp (container) {

        }
    };
});
